/**
 * Search Filter Fix v4.0
 * Production version - no console logs
 */

(function() {
  'use strict';

  if (document.body.getAttribute("id") !== "search") return;

  function getSearchTerm() {
    return new URLSearchParams(window.location.search).get('q') || '';
  }

  function getSpecialParams() {
    var currentParams = new URLSearchParams(window.location.search);
    var specialParams = new URLSearchParams();
    ['preview_theme_id', '_ab', '_fd', '_sc'].forEach(function(param) {
      var val = currentParams.get(param);
      if (val !== null) specialParams.set(param, val);
    });
    return specialParams;
  }

  function isVisible(el) {
    return el.offsetParent !== null;
  }

  function buildFilterURL() {
    var baseURL = window.location.pathname;
    var searchTerm = getSearchTerm();
    var params = new URLSearchParams();
    
    if (searchTerm) params.set('q', searchTerm);

    var specialParams = getSpecialParams();
    for (var pair of specialParams) {
      params.set(pair[0], pair[1]);
    }

    var addedFilters = new Set();

    document.querySelectorAll('#form-id input[type="checkbox"]:checked').forEach(function(input) {
      var form = input.closest('#form-id');
      if (form && !isVisible(form)) return;
      
      var name = input.getAttribute('name');
      var value = input.value;
      var filterKey = name + '=' + value;
      
      if (name && value && name.startsWith('filter.') && !addedFilters.has(filterKey)) {
        params.append(name, value);
        addedFilters.add(filterKey);
      }
    });

    document.querySelectorAll('#form-id input[type="number"]').forEach(function(input) {
      var form = input.closest('#form-id');
      if (form && !isVisible(form)) return;
      
      var name = input.getAttribute('name');
      if (!name || !name.startsWith('filter.')) return;
      
      var value = parseFloat(input.value) || 0;
      var min = parseFloat(input.getAttribute('min')) || 0;
      var max = parseFloat(input.getAttribute('max')) || 99999;
      
      if (name.includes('gte') && value > min) {
        params.set(name, value.toString());
      } else if (name.includes('lte') && value < max) {
        params.set(name, value.toString());
      }
    });

    return baseURL + '?' + params.toString();
  }

  function applyFilter() {
    window.location.href = buildFilterURL();
  }

  function initFilters() {
    document.querySelectorAll('#form-id input[type="checkbox"]').forEach(function(input) {
      var newInput = input.cloneNode(true);
      input.parentNode.replaceChild(newInput, input);
      newInput.addEventListener('change', function(e) {
        e.preventDefault();
        e.stopPropagation();
        applyFilter();
      });
    });

    document.querySelectorAll('.apply-price-filter').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        applyFilter();
      });
    });

    document.querySelectorAll('#form-id input[type="number"]').forEach(function(input) {
      var newInput = input.cloneNode(true);
      input.parentNode.replaceChild(newInput, input);
      newInput.addEventListener('keypress', function(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          applyFilter();
        }
      });
    });

    document.querySelectorAll('.range-slider input[type="range"]').forEach(function(slider) {
      slider.addEventListener('input', function() {
        var container = this.closest('.range-slider');
        if (!container) return;
        var nums = container.querySelectorAll('input[type="number"]');
        var ranges = container.querySelectorAll('input[type="range"]');
        if (nums.length >= 2 && ranges.length >= 2) {
          nums[0].value = ranges[0].value;
          nums[1].value = ranges[1].value;
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(initFilters, 300); });
  } else {
    setTimeout(initFilters, 300);
  }

})();
